import { PDFViewer } from '@react-pdf/renderer'
import Dialog from '@mui/material/Dialog'
import 'moment/locale/es'
import './vistaPrevia.css'
import { PdfFile } from './PdfFile'

export const VistaPreviaPrint = ({ auth, infoEmp, dataPreview, viewOptions, open, setOpen, urlLogo, nombre_columna_dias, infoGeneral, urlPDF, imgFirma }) => {

    return (
        <div>
            <Dialog
                className='ContainerModalVistaPrevia2'
                open={open}
                onClose={() => setOpen(false)}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <PDFViewer>
                    <PdfFile
                        auth={auth}
                        infoEmp={infoEmp}
                        dataPreview={dataPreview}
                        viewOptions={viewOptions}
                        urlLogo={urlLogo}
                        nombre_columna_dias={nombre_columna_dias}
                        infoGeneral={infoGeneral}
                        imgFirma={imgFirma}
                    />
                </PDFViewer>

                {/* <DialogContent> */}
                {/* <iframe src={urlPDF || ''}></iframe> */}
                {/* </DialogContent> */}

            </Dialog>
        </div >
    );
}